const dateReg =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)(?:Z|(\+|-)[\d|:]*)?$/;

const mongoIdReg = /^[0-9a-fA-F]{24}$/;
const intReg = /^-?\d+$/;

export default function (key, val) {
  if (typeof val !== "string") {
    return val;
  }
  switch (val) {
    case "":
      return val;
    case "null":
      return null;
    case "undefined":
      return void 0;
    case "true":
    case "yes":
    case "on":
      return true;
    case "false":
    case "no":
    case "off":
      return false;
    default:
      switch (false) {
        case !isFinite(val):
          // Ids (Meta ad ids, etc.) can be integers past Number.MAX_SAFE_INTEGER —
          // Number(val) would silently round them, so keep those as strings.
          if (val.match(mongoIdReg)) return val;
          if (intReg.test(val) && !Number.isSafeInteger(Number(val)))
            return val;
          return Number(val);
        case !dateReg.test(val):
          return new Date(val);
        default:
          return val;
      }
  }
}
